import React, { useCallback, useRef, useState } from "react";
import { mobile } from "src/utils/platformUtils";
import adService from "src/services/adService";
import FreeModelDrawer from "src/components/AnimatedButton/FreeModelDrawer";

// Centralizes the FREE-model ad gate behavior (web: drawer/AdSense, native: AdMob rewarded).
// Keep it UI-driven to match the behavior used in CreditOptionButton.
export function useFreeModelExecutionGate() {
  const [open, setOpen] = useState(false);
  const pendingExecutionRef = useRef<null | (() => void)>(null);

  const close = useCallback(() => {
    setOpen(false);
    pendingExecutionRef.current = null;
  }, []);

  const handleAdComplete = useCallback(() => {
    setOpen(false);
    const fn = pendingExecutionRef.current;
    pendingExecutionRef.current = null;
    fn?.();
  }, []);

  // const gate = useCallback(async (execute: () => void) => {
  //   const isNative = mobile && adService.isNativePlatform();

  //   if (isNative) {
  //     // Native: show AdMob rewarded ad; execute after completion or on load/show failure (graceful degradation).
  //     try {
  //       await new Promise<void>((resolve, reject) => {
  //         adService
  //           .showRewardedAd({
  //             onAdLoading: () => console.log("[useFreeModelExecutionGate] Native ad loading..."),
  //             onAdLoaded: () => console.log("[useFreeModelExecutionGate] Native ad loaded"),
  //             onAdShowing: () => console.log("[useFreeModelExecutionGate] Native ad showing"),
  //             onAdCompleted: () => {
  //               console.log("[useFreeModelExecutionGate] Native ad completed");
  //               resolve();
  //             },
  //             onAdSkipped: () => {
  //               console.log("[useFreeModelExecutionGate] Native ad skipped");
  //               reject(new Error("Ad skipped"));
  //             },
  //             onAdFailed: (error) => {
  //               console.error("[useFreeModelExecutionGate] Native ad failed:", error);
  //               reject(new Error(typeof error === "string" ? error : "Ad failed"));
  //             },
  //             onRewardEarned: (reward) => console.log("[useFreeModelExecutionGate] Reward earned:", reward),
  //           })
  //           .catch((err) => reject(err));
  //       });

  //       execute();
  //     } catch (err) {
  //       const message = err instanceof Error ? err.message : String(err);
  //       // Only block execution when user explicitly skipped the ad. On load/show failure (e.g. no fill in simulator), let user proceed.
  //       if (message === "Ad skipped") {
  //         // User closed ad without completing – do not run action.
  //         return;
  //       }
  //       console.warn("[useFreeModelExecutionGate] Ad unavailable, proceeding without ad:", message);
  //       execute();
  //     }
  //     return;
  //   }

  //   // Web: open drawer and execute after onAdComplete.
  //   pendingExecutionRef.current = execute;
  //   setOpen(true);
  // }, []);

  const gate = useCallback(async (execute: () => void) => {

    execute();
    return;
  }, []);

  const GateDrawer = useCallback(() => {
    return <FreeModelDrawer open={open} onClose={close} onAdComplete={handleAdComplete} />;
  }, [close, handleAdComplete, open]);

  return {
    gate,
    GateDrawer,
    close,
  };
}
